<template>
	<b-navbar toggleable="md" type="dark" variant='primary' v-if='isLogged'>
		<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
		<b-navbar-brand>
			<h6 class="text-black my-auto mr-4">TangoAdmin</h6>
		</b-navbar-brand>
		<b-collapse is-nav id="nav-collapse">
			<b-navbar-nav>
				<b-nav-item to="/home">Home</b-nav-item>
				<b-nav-item
					v-if='fanzonesByType(0) || fanzonesByType(1)'
					to='/fanzones'
				>
					Festiwale
				</b-nav-item>

				<b-nav-item
					v-if='fanzonesByType(3)'
					to='/fanzones-places'
				>
					Miejsca
				</b-nav-item>

				<b-nav-item
					v-if='fanzonesByType(2)'
					to='/fanzones-urban-actions'
				>
					Akcje Miejskie
				</b-nav-item>

				<b-nav-item
					v-if='fanzonesByType(4)'
					to='/fanzones-roadtours'
				>
					Trasy koncertowe
				</b-nav-item>

			</b-navbar-nav>
			<b-navbar-nav class="ml-auto">
				<b-nav-item-dropdown right>
					<template #button-content>
						<b-icon icon='person-fill' />
            {{email}}
          </template>
					<b-dropdown-item href="#" @click='() => handleLogoutClick()'>
						<b-icon icon='box-arrow-right' class='icon-menu' />
						<span class='icon-item-menu'>Wyloguj się</span>
					</b-dropdown-item>
				</b-nav-item-dropdown>
			</b-navbar-nav>
		</b-collapse>
	</b-navbar>
</template>

<script>
	import store from '@/store'
	import {
    BIcon,
		BIconPersonFill,
		BIconBoxArrowRight,
  } from 'bootstrap-vue'

	export default {
		components: {
			BIcon,
			BIconPersonFill,
			BIconBoxArrowRight,
		},
		mounted:() => {
			console.log('NAVBAR MOUNTED', store.state.fanzones.fanzonesByTypeId)
		},
		computed: {
			isLogged: () => {
				try {
					return store.state.user.isLogged
				} catch {
					return null
				}
			},
			email: () => store.state.user.email,
		},
		methods: {
			fanzonesByType: (typeId) =>
				store.state.fanzones.fanzonesByTypeId[typeId]
			,
			handleLogoutClick() {
				store.dispatch('logout')
			}
		}
	}
</script>

<style>
	.navbar-dark .navbar-nav .nav-link {
		color: #e5e5e5;
	}
	.router-link-active {
		color: white!important;
	}
	.icon-item-menu {
		display: inline-block;
		margin-left: 28px;
	}
	.icon-menu {
		position: absolute;
		margin-top: 1px;		
	}
</style>